import { createSlice } from '@reduxjs/toolkit';
import { initialState, commonReducers } from './fileVersionHistory.slice';

const priceGuideVersionHistorySlice = createSlice({
  name: 'priceGuideVersionHistory',
  initialState,
  reducers: { ...commonReducers },
});

export default priceGuideVersionHistorySlice.reducer;
export const {
  setOpenFileVersionHistory,
  setOpenDeleteVersionConfirmationModal,
  addToFileVersions,
  getNextVersions,
  deletedLastVersion,
} = priceGuideVersionHistorySlice.actions;
